<template>
    <div class="product__nav">
        <ul id="ulSeries">
            <li :class="selectedid == 'tlAllSeries' ? 'product__nav--ttl': ''"><span><a href="/products" v-bind:title="$t('tlAllSeries')" >{{$t('tlAllSeries')}}</a></span></li> 
            <li :class="_props.selectedid == item.name ? 'product__nav--ttl' : ''" v-for="item in series">
              <a v-bind:href="'/products?selected=' + item.id + '&series=' + item.name" v-bind:title="item.name">{{item.name}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import $ from "jquery";
import productApi from "../../api/product-api";
export default {
  props: ["selectedid"],
  name: "SubNavi",
  data() {
    return {
      series: []
    };
  },
  mounted: function() {
    var _this = this;
    $(function() {
      _this.getAllSerieses(function(data) {
        _this.series = data;
        // for (var i = 0; i < data.length; i++) {
        //   $("#ulSeries").append(
        //     "<li class='"+(_this._props.selectedid == data[i].name ? "product__nav--ttl" : "")+"'><span><a href='/products?selected=" +
        //       data[i].id +
        //       "&series="+data[i].name+"' title='" +
        //       data[i].name +
        //       "'>" +
        //       data[i].name +
        //       "</a></span></li>"
        //   );
        // }
      });
    });
  },
  methods: {
    getAllSerieses(callback) {
      productApi.getAllSerieses(
        function(response) {
          callback(response);
        },
        function(error) {}
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/product/subnavi.vue